import _WidgetBase from 'dijit/_WidgetBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./AddressFinderHome.html');
//import "../AddressFinder/AddressFinderTypes";
import _EntityViewMixin from './EntityView';
import { EntityViewTypes } from "./EntityViewTypes";

interface GenericEntityViewConfig {
    entityId: string,
    entityClass: string,
    label: string,
    labelProperty?: string,
    destination?: HTMLElement | "dlg" | "tab",
    additionalParams?: Object,
    contextName?: string,
    tabContainerName?: string,
    events?: {
        onShow?: () => void,
        onClose?: () => void,
        onClone?: () => void,
        onDataLoaded?: () => void,
        onViewContentSet?: () => void,
        onDelete?: () => void,
        afterDelete?: () => void
    }
}

class GenericEntityView extends compose(_EntityViewMixin<more.EntityAPIResult>) {
    //templateString = template; // nur falls nötig ein eigenes laden!

    onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {
        return null;
    }

    onShow() {
        // zb weitere Buttons zum Dlg oder in den Tab einfügen...
    }

    onDataLoaded() {

    }

    onDelete() {

    }

    afterDelete() {

    }

    onClose() {

    }

    onViewContentSet() {
        // wird in Kindklasse überdefiniert
    }

    setupWithoutEntity(viewData: EntityViewTypes.EntityViewResponse<more.EntityAPIResult> | string,
        label?: string,
        destination?: HTMLElement | "dlg" | "tab",
        tabContainerName?: string,
        events?: {
            onShow?: () => void,
            onClose?: () => void,
            onViewContentSet?: () => void
        }) {

        this.setup(null,
            null,
            label,
            null,
            destination,
            null,
            null,
            tabContainerName,
            events);

        this.setViewData(viewData);
    }

    /**
* Grundkonfiguration der View. Die View wird nach dem Setup geöffnet (je nach destination).
*/
    setup(config: GenericEntityViewConfig)

    /**
* Grundkonfiguration der View. Die View wird nach dem Setup geöffnet (je nach destination).
* @param entityId
* @param label
* @param additionalParams
* @param tabContainerName
* @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
*/
    setup(entityId: string,
        entityClass: string,
        label: string,
        labelProperty: string,
        destination?: HTMLElement | "dlg" | "tab",
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,
        events?: {
            onShow?: () => void,
            onClose?: () => void,
            onClone?: () => void,
            onDataLoaded?: () => void,
            onViewContentSet?: () => void,
            onDelete?: () => void,
            afterDelete?: () => void
        })

 /**
* Grundkonfiguration der View. Die View wird nach dem Setup geöffnet (je nach destination).
* @param entityId
* @param label
* @param additionalParams
* @param tabContainerName
* @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
*/
    setup(param1: string | GenericEntityViewConfig,
        entityClass?: string,
        label?: string,
        labelProperty?: string,
        destination?: HTMLElement | "dlg" | "tab",
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,
        events?: {
            onShow?: () => void,
            onClose?: () => void,
            onClone?: () => void,
            onDataLoaded?: () => void,
            onViewContentSet?: () => void,
            onDelete?: () => void,
            afterDelete?: () => void
        }) {

        let entityId: string = null;

        // Legacy-Handling für
        if (typeof (param1) == "string") {
            entityId = param1;
        } else if (param1 && typeof (param1) == "object") {
            let config = param1 as GenericEntityViewConfig;
            entityClass = config.entityClass;
            entityId = config.entityId;
            label = config.label;
            labelProperty = config.labelProperty;
            destination = config.destination;
            additionalParams = config.additionalParams;
            contextName = config.contextName;
            tabContainerName = config.tabContainerName;
            events = config.events;
        } else {
            //return; // nein nicht return - sonst geht setup ohne Entity ggf nicht
        }

        this.config.entityClassname = entityClass;
        this.config.labelProperty = labelProperty;


        // wenns schon geladen war und wir sind nochmal hier, dann wird wahrscheinlich ein Reload gewünscht sein
        let bDoReload = false;
        if (entityId == this.entityID && !!entityId && this.viewData) {
            bDoReload = true;
        }

        if (events) {
            if (events.onClose != undefined) {
                this.onClose = events.onClose;
            }

            if (events.onClone != undefined) {
                this.onClone = events.onClone;
            }

            if (events.onShow != undefined) {
                this.onShow = events.onShow;
            }

            if (events.onDataLoaded != undefined) {
                this.onDataLoaded = events.onDataLoaded;
            }

            if (events.onViewContentSet != undefined) {
                this.onViewContentSet = events.onViewContentSet;
            }

            if (events.onDelete != undefined) {
                this.onDelete = events.onDelete;
            }

            if (events.afterDelete != undefined) {
                this.afterDelete = events.afterDelete;
            }
        }

        if (destination == "tab" && !tabContainerName) destination = "dlg";

        if (contextName) this.setContextName(contextName);

        if (additionalParams) this.setAdditionalRequestParameters(additionalParams);

        if (destination === "dlg" || !destination) {
            this.showAsDlg(entityId, label, tabContainerName);
        } else if (destination instanceof HTMLElement) {
            this.showAtNode(entityId, label, destination);
        } else if (destination == "tab") {
            this.showAsTab(entityId, label, tabContainerName);
        }

        if (bDoReload) this.reload();
    }

    setDeletePrivilege(userroleDelete: string, featurePathDelete?: string) {

        if (!this.config.deleteOptions) this.config.deleteOptions = {
            deleteEntityFunctionname: null,
            featurePathDelete: null,
            userroleDelete: null
        };

        this.config.deleteOptions.userroleDelete = userroleDelete;
        if (featurePathDelete == null || typeof (featurePathDelete) == "string") {
            this.config.deleteOptions.featurePathDelete = featurePathDelete;
        }
        this.checkPrivileges();
    }


    postCreate(): void {

        this.config = {
            entityClassname: null, //
            labelProperty: null,
            entityClassPrintname: null,
        }
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(GenericEntityView);
